var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2393",
    "data-name": "Group 2393",
    transform: "translate(-171 -2586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkdin__x2C__social__x2C_media_x2C__logo",
    transform: "translate(155 2586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M33.437,16H18.563A2.573,2.573,0,0,0,16,18.563V33.437A2.573,2.573,0,0,0,18.563,36H33.437A2.573,2.573,0,0,0,36,33.437V18.563A2.573,2.573,0,0,0,33.437,16ZM22.875,25.659v6.174H20.167V24.042h2.708Zm-1.36-2.778a1.365,1.365,0,1,1,1.365-1.365A1.365,1.365,0,0,1,21.515,22.88Zm10.318,4.7v4.25H29.5V28.049c0-.906-.1-2.072-1.34-2.072-1.261,0-1.451.987-1.451,2.007v3.85h-2.25V24.042h2.167v1.042h.023a2.5,2.5,0,0,1,2.294-1.042c1.986,0,2.661.939,2.846,2.409a9.013,9.013,0,0,1,.061,1.134Z",
    transform: "translate(0 -16)",
    fill: "#f9f9f9",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.ed88874388cddb8b506a0edf799f7769.svg";
export { ForwardRef as ReactComponent };